module.exports = __webpack_public_path__ + "img/ct_carry.b9b17969.png";